import React, { useEffect } from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { IoIosArrowDown } from 'react-icons/io';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Typewriter from 'typewriter-effect';

import { Container, Social, Icon } from './styles';

export default function About() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Container id='home' data-aos='fade-right'>
        <h1>Caio Mantovani Borba</h1>
        <Typewriter
          onInit={(typewriter) => {
            typewriter.pauseFor(1000).typeString('Front-End Developer').start();
          }}
        />

        <Social>
          <a
            href='https://github.com/CaioMantovaniBorba'
            target='_blank'
            rel='noopener noreferrer'
          >
            {' '}
            <FaGithub className='icon-upload' size='32' color='#fff' />
          </a>

          <a
            href='https://br.linkedin.com/in/caio-mantovani-borba'
            target='_blank'
            rel='noopener noreferrer'
          >
            <FaLinkedin className='icon-upload' size='32' color='#fff' />
          </a>

          <a href='mailto:caiovmborba@gmail.com'>
            <FiMail className='icon-upload' size='32' color='#fff' />
          </a>
        </Social>

        <Icon>
          <a href='#about'>
            <IoIosArrowDown size='64' color='#fff' />
          </a>
        </Icon>
      </Container>
    </>
  );
}
